import { useState } from "react";
import { API } from "../api";
import { Button } from "@mui/material";

export default function UploadExcel() {
  const [file, setFile] = useState();

  const upload = async () => {
    if (!file) {
      alert("กรุณาเลือกไฟล์");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
	  const res = await API.post("/admin/upload/", formData, {
	    headers: {
	      "Content-Type": "multipart/form-data",
	    },
	  });	
  
      alert("✅ " + res.data.message);

      // ߔ堲eload list หลัง upload
      window.location.reload();

    } catch (err) {
      console.error(err);
	  const msg =
	    err.response?.data?.error ||
	    err.response?.data?.detail ||
	    "Upload ไม่สำเร็จ";
	
	  alert("❌ " + msg);
    }
  };
  
  return (
    <div>
      <h2>ߓ堕pload Excel</h2>
	  <a href="/api/download-template/" target="_blank">
	    <button>Download Template</button>
	  </a>
      <input type="file" onChange={e => setFile(e.target.files[0])} />
      <br /><br />

      <Button variant="contained" onClick={upload}>
        Upload
      </Button>
    </div>
  );
}